var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"text":"","prominent":"","type":"error","icon":"mdi-cloud-alert"}},[_c('h3',[_vm._v("Não foram encontrad"+_vm._s(_vm.gender)+"s "+_vm._s(_vm.asset))]),_c('span',[_vm._v("Não foram encontrados dados dentro dos critérios específicados. Por favor pesquise por critérios distintos.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }